import { schema } from 'normalizr';

const personalCareTask = new schema.Entity('personalCareTasks');

export default personalCareTask;

